"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailInput = exports.EmailInputTypes = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const result_1 = (0, tslib_1.__importDefault)(require("lodash/result"));
const creatable_1 = (0, tslib_1.__importDefault)(require("react-select/creatable"));
const react_select_1 = require("react-select");
const lib_1 = require("../../lib");
var EmailInputTypes;
(function (EmailInputTypes) {
    EmailInputTypes["TO"] = "To";
    EmailInputTypes["CC"] = "Cc";
    EmailInputTypes["BCC"] = "Bcc";
})(EmailInputTypes = exports.EmailInputTypes || (exports.EmailInputTypes = {}));
const EmailInputControlComponent = (type, show, onClick) => props => {
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'select-email-input__control-wrapper' }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'select-email-input__control-label' }, { children: [type, ":"] }), void 0), (0, jsx_runtime_1.jsx)(react_select_1.components.Control, Object.assign({}, props), void 0), show && show.Cc ? ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'select-email-input__control-btn', onClick: onClick ? () => onClick(EmailInputTypes.CC) : undefined }, { children: EmailInputTypes.CC }), void 0)) : null, show && show.Bcc ? ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'select-email-input__control-btn', onClick: onClick ? () => onClick(EmailInputTypes.BCC) : undefined }, { children: EmailInputTypes.BCC }), void 0)) : null] }), void 0));
};
const EmailInput = ({ emails = [], value, onChange, onBlur, onFocus, loading, multi, emailType = EmailInputTypes.TO, show, onButtonClick }) => {
    const ref = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (ref && ref.current) {
            // console.log('focus');
            ref.current.blur();
            ref.current.focus();
        }
        else {
            // console.log('no focus');
        }
    }, []);
    return ((0, jsx_runtime_1.jsx)(creatable_1.default, { ref: ref, className: (0, lib_1.classnames)((0, lib_1.bem)('select-email-input')), classNamePrefix: 'select-email-input', placeholder: '', 
        // autoFocus={true}
        isMulti: multi, tabSelectsValue: true, isSearchable: true, isLoading: loading, value: Array.isArray(value)
            ? value.map(email => ({ label: email, value: email }))
            : undefined, onBlur: onBlur, onFocus: onFocus, onChange: values => {
            if (onChange)
                onChange(Array.isArray(values)
                    ? values.map(({ value }) => value)
                    : (0, result_1.default)(values, 'value', ''));
        }, options: emails.map(email => ({ label: email, value: email })), components: {
            Control: EmailInputControlComponent(emailType, show, onButtonClick)
        } }, void 0));
};
exports.EmailInput = EmailInput;
//# sourceMappingURL=EmailInput.js.map